module.exports = __webpack_public_path__ + "media/icons/3@3x-75d01ba5.svg";